<template>
  <div>
    <div
      class="blockUI blockOverlay"
      style="
        z-index: 1100;
        border: none;
        margin: 0px;
        padding: 0px;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        background-color: rgb(231 231 231);
        opacity: 1;
        cursor: wait;
        position: fixed;
      "
    ></div>
    <div
      class="blockUI blockMsg blockPage"
      style="
        z-index: 1101;
        position: fixed;
        padding: 0px;
        margin: 0px;
        width: auto;
        top: 50%;
        left: 50%;
        text-align: center;
        color: rgb(0, 0, 0);
        border: 0px;
        cursor: default;
        opacity: 0.999938;
        transform: translate(-50%, 0);
      "
    >
      <div class="blockui">
        <span>لطفا منتظر بمانید</span
        ><span class="spinner spinner-danger"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
